import './index.scss';

import CheckoutContainer from 'Components/Checkout/CheckoutCotainer';
import { useSelectActiveProduct, useTrans } from 'core/hooks';
import { actions } from 'core/redux/features/booking';
import { actions as sharedActions } from 'core/redux/features/shared';
import { actions as navActions } from 'core/redux/features/shared/nav';
import { AppState } from 'core/redux/reducers';
import { addClass, removeClass } from 'dom-helpers';
import addCss from 'dom-helpers/css';
import qsa from 'dom-helpers/querySelectorAll';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { useDataLayerCheckout } from 'utils/dataLayer';
import { useGAAddToCart } from 'utils/googleAnalytics';
import { useKlaviyoTrackCheckoutStarted } from '../../utils/klaviyo';
import { useSnapChatAddToCart } from '../../utils/snapchatAds';
import PopUpMenus from './Components/PopUpMenus';
import FormSteps from './Steps';
import { useHandleBookingHoldId, useShowPopupLastStockOnHold } from './hooks';

function BookingComponent() {
  useShowPopupLastStockOnHold();
  useHandleBookingHoldId();
  useKlaviyoTrackCheckoutStarted();
  useSnapChatAddToCart();
  useGAAddToCart();
  useDataLayerCheckout();

  const match = useRouteMatch<{ step: string }>();
  const dispatch = useDispatch();
  const product = useSelectActiveProduct();

  const { steps, activeStep, stepData, loading, deviceType } = useSelector(
    (state: AppState) => ({
      steps: state.booking.steps,
      activeStep: state.booking.activeStepIndex,
      stepData: state.booking.form_data,
      loading: state.booking.loading,
      deviceType: state.deviceType,
    }),
  );

  const [menuModalHidden, setMenuModalHidden] = useState(true);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (activeStep === 0) {
      return;
    }

    const findStepIndex = Object.values(steps).findIndex(
      item => item.route === match.params.step,
    );

    const step = stepData[findStepIndex];
    if (step && step.complete && findStepIndex !== activeStep) {
      dispatch(actions.setActiveStepIndex(findStepIndex));
    }
  }, []);

  const onHideModal = () => {
    setMenuModalHidden(!menuModalHidden);
  };

  const isPaymentFailed = useSelector(
    (state: AppState) => state.payment_failed,
  );
  const trans = useTrans();
  useEffect(() => {
    if (isPaymentFailed) {
      dispatch(sharedActions.notifyAlert(trans('payment_failed_error_msg')));
    }
  }, [dispatch, isPaymentFailed, trans]);

  // hide boxes
  useEffect(() => {
    const findBoxEl = document.getElementById('eb-boxb-root');
    if (findBoxEl) {
      addClass(findBoxEl, 'hide');
    }

    window.scroll(0, 0);

    return () => {
      if (findBoxEl) {
        removeClass(findBoxEl, 'hide');
      }
    };
  }, []);

  //show main menu
  useEffect(() => {
    if (deviceType !== 'mobile') {
      return;
    }

    setTimeout(() => {
      addCss(qsa(document, 'html')[0], {
        overflow: 'hidden',
      });
    }, 500);
    dispatch(navActions.hideMenu('main', false));
    return () => {
      dispatch(navActions.hideMenu('main', true));

      addCss(qsa(document, 'html')[0], {
        overflow: '',
      });
    };
  }, [deviceType, dispatch]);

  useEffect(() => {
    const elFooter = qsa(document, '.footer-wrap');
    if (elFooter.length > 0) {
      addCss(elFooter[0], {
        display: 'none',
      });
    }
  }, []);

  return (
    <>
      <PopUpMenus hide={menuModalHidden} onHide={onHideModal} />
      <CheckoutContainer
        loading={loading}
        title={product?.name ?? ''}
        activeStep={activeStep}
        steps={steps}
        hideStep={deviceType === 'mobile'}
      >
        <FormSteps onHideMenuModal={onHideModal} />
      </CheckoutContainer>
      <div className="is-clearfix" />
      <div className="spacer-s" />
    </>
  );
}

// const bookingRoot =
//   process.env.NODE_ENV !== 'production'
//     ? hot(BookingComponent)
//     : BookingComponent;

export default BookingComponent;
